module.exports = __webpack_public_path__ + "static/media/catering-4.62923094.jpg";